import { render, staticRenderFns } from "./UIBtnLink.vue?vue&type=template&id=35e752d6&scoped=true&"
import script from "./UIBtnLink.vue?vue&type=script&lang=ts&"
export * from "./UIBtnLink.vue?vue&type=script&lang=ts&"
import style0 from "./UIBtnLink.vue?vue&type=style&index=0&id=35e752d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e752d6",
  null
  
)

export default component.exports